import './productSubTitle.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

type ProductSubTitleProps = {
    textKey: string;
};

export default function ProductSubTitle(props: ProductSubTitleProps) {
    const { textKey } = props;

    const { t } = useTranslation('templatePages');

    return (
        <h2 className='product-sub-title'>
            <span>{t(textKey)}</span>
            <hr />
        </h2>
    );
}
